import i18next from 'i18next';

i18next.addResources('es', 'PROCEDURES', {
  REVIEW_TITLE: 'Revisión de Datos',
  REVIEW_SUBTITLE: 'Por favor, verifique la información ingresada antes de finalizar el trámite.',
  REVIEW_FOOTER: 'Al presionar "Finalizar", se enviará la solicitud para su revisión.',
});

i18next.addResources('es', 'COMMON', {
  YES: 'Sí',
  NO: 'No',
});

i18next.addResources('en', 'PROCEDURES', {
  REVIEW_TITLE: 'Data Review',
  REVIEW_SUBTITLE: 'Please verify the entered information before finalizing the procedure.',
  REVIEW_FOOTER: 'By pressing "Finalize", the request will be sent for review.',
});

i18next.addResources('en', 'COMMON', {
  YES: 'Yes',
  NO: 'No',
});
